import { useApiQuery } from 'mf_core/query';

export function useCMPPaymentTerm(enabled: boolean) {
  return useApiQuery(
    '/payment/v1/gateways/cmp/reseller-payment-term',
    undefined,
    { enabled, refetchOnWindowFocus: false }
  );
}
